<div class="page-wrap terms-condition">
    <div class="homeSlider">
        <div class="item">
        <img src="assets/images/slide1.jpg" alt="banner">
        </div>
    </div>
    <div class="container">
        <div class="row mb-5">
            <div class="col-12 col-md-12 col-lg-12">
                <div class="covers">
                    <h4 class="hdx"><span>Copyright Policy</span></h4>
                    <div class="page-content">
                        <p>
                            Contents of this website may not be reproduced partially or fully, without due permission from Department of Health and Family Welfare. If referred to as a part of another website, the source must be appropriately acknowledged. However, the material has to be reproduced accurately and not to be used in a derogatory manner or in a misleading context. However, the permission to reproduce this material shall not extend to any material which is identified as being copyright of a third party. Authorization to reproduce such material must be obtained from the departments/copyright holders concerned.
                        </p>
                        <p>
                            These terms and conditions shall be governed by and construed in accordance with the Indian Laws. Any dispute arising under these terms and conditions shall subject to the exclusive jurisdiction of the courts of India.
                         </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

